import React, { useState } from "react";
import { toast } from "react-toastify";

import RowActions from "./row-actions";
import { formatPercent, parsePercent } from "../../helpers/commissionFormat";

const TiersTable = ({ tiers, onUpdate, editingKey, setEditingKey, isSaving }) => {
  const [draft, setDraft] = useState(null);

  const keyFor = (tier) => `tier:${tier}`;

  const handleEdit = (row) => {
    setDraft({ newRate: String(row.newRate), repeatRate: String(row.repeatRate) });
    setEditingKey(keyFor(row.tier));
  };

  const handleCancel = () => {
    setDraft(null);
    setEditingKey(null);
  };

  const handleConfirm = async (row) => {
    const newRate = parsePercent(draft.newRate);
    const repeatRate = parsePercent(draft.repeatRate);

    if (newRate === null || repeatRate === null) {
      toast.error("Percentages must be a number from 0.0 to 100.0 with at most one decimal.");
      setDraft({
        newRate: newRate === null ? String(row.newRate) : draft.newRate,
        repeatRate: repeatRate === null ? String(row.repeatRate) : draft.repeatRate,
      });
      return;
    }

    if (await onUpdate(row.tier, { newRate, repeatRate })) {
      handleCancel();
    }
  };

  const renderRateCell = (row, field, isEditing) =>
    isEditing ? (
      <input
        type="number"
        name={field}
        step={0.1}
        min={0}
        max={100}
        className="commissions-input"
        value={draft[field]}
        onChange={(e) => setDraft({ ...draft, [field]: e.target.value })}
      />
    ) : (
      formatPercent(row[field])
    );

  return (
    <div className="commissions-table" data-testid="commission-tiers-table">
      <div className="commissions-table-header">
        <h3>Tiers &amp; Payout Rates</h3>
      </div>
      <table>
        <thead>
          <tr>
            <th>Tier</th>
            <th>New</th>
            <th>Repeat</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {tiers.map((row) => {
            const isEditing = editingKey === keyFor(row.tier);

            return (
              <tr key={row.tier} className={isEditing ? "commissions-row-editing" : undefined}>
                <td>{`Tier ${row.tier}`}</td>
                <td>{renderRateCell(row, "newRate", isEditing)}</td>
                <td>{renderRateCell(row, "repeatRate", isEditing)}</td>
                <td className="commissions-actions">
                  <RowActions
                    isEditing={isEditing}
                    isEditDisabled={editingKey !== null}
                    isSaving={isSaving}
                    onEdit={() => handleEdit(row)}
                    onConfirm={() => handleConfirm(row)}
                    onCancel={handleCancel}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TiersTable;
